module.exports = __webpack_public_path__ + "static/rn-creative-black-5e13fb6d59ef0bf48a6974971a601189.png";